<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main.vue'
import baseMixin from '@/mixins/baseMixin'
import RegisteredDevices from '@/components/devices/registered-devices.vue'
export default {
  components: {
    Layout,
    RegisteredDevices,
  },
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: appConfig.description }],
    }
  },
  mixins: [baseMixin],
  props: {
    candidateId: {
      type: String,
      required: true,
      default: '',
    },
  },
  computed: {
    compTitle() {
      return this.$t('devices.title')
    },
    candidateDevices() {
      return this.candidateId?.length
        ? this.$store.getters['candidate/getCandidateDevices'](this.candidateId)
        : []
    },
  },

  async mounted() {
    if (!this.candidateDevices?.length) {
      await this.$store.dispatch(
        'candidate/getRegisteredDevices',
        this.candidateId
      )
    }
  },
}
</script>

<template>
  <Layout>
    <BasePageTitle :title="compTitle" />
    <RegisteredDevices :devices="candidateDevices" />
  </Layout>
</template>
